import React from "react";
import GoogleAnalytics from "react-ga";
import { hotjar } from "../../../core/hotjar";

GoogleAnalytics.initialize("UA-36711748-1");

export const withTracker = (WrappedComponent, options = {}) => {
  const trackPage = page => {
    GoogleAnalytics.set({
      page,
      ...options
    });
    GoogleAnalytics.pageview(page);
    // hjid: Stands for 'Hotjar ID' - Your site's ID.
    // hjsv: Stands for 'Hotjar Snippet Version' - The version of the Tracking Code you are using.
    hotjar(1035664, 6);
  };

  const HOC = class extends React.Component {
    componentDidMount() {
      const page = this.props.location.pathname;
      trackPage(page);
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
};
